import React from "react";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { Link } from "gatsby";
import "./featuredEdition.scss";

export interface IFeaturedEdition {
  className?: string;
  notas: {
    tags: string[];
    titulo: string;
    description: string;
    imageURL: string;
    slug: string;
    fecha?: string;
    tiempo?: string;
    autor?:string;
  }[];
}

const FeaturedEdition = (props: IFeaturedEdition) => {
  const { notas } = props;
  const compClass = "m-featured__edition";
  return (
    <>
      {notas.map((nota, key) => (
        <div className={`${compClass} ${
          props.className ? props.className : ""
        }`.trim()} key={key}>
          <Link to={nota.slug}>
            <img src={nota.imageURL} alt={nota.autor} />
          </Link>
          <div className={`${compClass}-container`}>
            <Link to={notas[0].tags[0][0] === "Editoriales" ? "/editoriales" : "/" + nota.slug.split("/", 2).join("")}>
              <p className={`${compClass}-category`}>
                {nota.tags?.join(", ")}
              </p>
            </Link>
            <p className={`${compClass}-title`}>{nota.titulo}</p>
            <p className={`${compClass}-content`}>{nota.description}</p>
            <div className={`${compClass}-description`}>
              <span className={`${compClass}-author`}>
                Por: {nota.autor}
              </span>
              <span className={`${compClass}-date`}>
                <FaCalendarAlt />
                {nota.fecha}
              </span>
              <span className={`${compClass}-time`}>
                <FaClock />{nota.tiempo}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FeaturedEdition;
